import './CreditCard.css';

const CreditCard = ({ cardNumber, nameOnCard, expiryMonth, expiryYear, cvv, isFlipped }) => {
    const formattedCardNumber = cardNumber?.replace(/(.{4})/g, '$1 ').trim() || '**** **** **** ****';
    const formattedName = nameOnCard?.toUpperCase() || 'KART ÜZERİNDEKİ İSİM';
    const formattedExpiry = `${expiryMonth || 'MM'}/${expiryYear || 'YY'}`;

    return (
        <div className="credit-card">
            <div className={`credit-card-inner ${isFlipped ? 'flipped' : ''}`}>
                <div className="credit-card-front">
                    <div className="card-content">
                        <div className="card-top">
                            <div className="card-chip">
                                <i className="fas fa-sim-card"></i>
                            </div>
                            <div className="card-brand">
                                <i className="fab fa-cc-visa"></i>
                            </div>
                        </div>
                        <div className="card-number">{formattedCardNumber}</div>
                        <div className="card-bottom">
                            <div className="card-info">
                                <div className="card-holder">
                                    <div className="label">KART SAHİBİ</div>
                                    <div className="value">{formattedName}</div>
                                </div>
                                <div className="card-expiry">
                                    <div className="label">SON KULLANIM</div>
                                    <div className="value">{formattedExpiry}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="credit-card-back">
                    <div className="magnetic-stripe"></div>
                    <div className="signature-panel">
                        <div className="cvv-box">{cvv || '***'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreditCard;

